var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-reader"},[_vm._t("reader",[_c('input',{staticClass:"file-reader__control",attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.handleOnChange}})],{"accept":_vm.accept,"onchange":_vm.handleOnChange})],2)}
var staticRenderFns = []

export { render, staticRenderFns }